import React from 'react'

import { cn } from '../../utils/cn'

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  noPadding?: boolean
  roundTopLeft?: boolean
  roundBottomright?: boolean
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        style={{
          ...props.style,
        }}
        className={cn(
          !props.noPadding && 'p-5',
          'border-tan-150 rounded-none border bg-white',
          className
        )}
        {...props}
      >
        {props.children}
      </div>
    )
  }
)
Card.displayName = 'Card'

export { Card }
